import { Component, EventEmitter, Input, Output } from "@angular/core"
import { ActionButtonComponent } from "../nav-bar/action-button.component"
import { IconComponent } from "../icon/icon.component"
import { CommonModule } from "@angular/common"
import { DeleteButtonComponent } from "../buttons/delete-button.component"

@Component({
    selector: 'branding-controls-wrapper',
    template: `
<div class="branding-controls-wrapper" [ngClass]="{ selected: selected }">
  <div class="controls">
    <action-button 
      [disabled]="selected" 
      [text]="selected ? 'SELECTED' : 'SELECT'"
      (click)="!selected && select.emit()"
    ></action-button>
    <div style="flex:1;"></div>
    <action-button *ngIf="isAccountDefault || onAccount"
      [disabled]="isAccountDefault" 
      [text]="isAccountDefault ? 'ACCOUNT DEFAULT' : 'SELECT AS ACCOUNT DEFAULT'"
      (click)="!isAccountDefault && setAsAccountDefault.emit()"
    ></action-button>
  </div>
  <ng-content></ng-content>
  <div class="controls bottom" *ngIf="!hideDelete || showEdit">
    <delete-button *ngIf="!hideDelete && onAccount" [deleteTitle]="deleteTitle" [deleteText]="deleteText" (delete)="delete.emit()"></delete-button>
    <div style="flex:1;"></div>
    <ng-container *ngIf="showEdit">
      <icon class="edit" *ngIf="!editing && onAccount" [icon]="'EDIT'" [i18]="true" (click)="edit.emit(true)"></icon>
      <action-button *ngIf="!!editing" [text]="'DONE'" (click)="edit.emit(false)"></action-button>
    </ng-container>
  </div>
</div>
`,
    styles: [`
  :host { width: 100%; }
  .controls { display: flex; align-items: center; justify-content: space-between; }
  .branding-controls-wrapper { border: 1px solid #cccc; border-radius: 6px; padding: 15px; }
  .branding-controls-wrapper.selected { border: 1px solid var(--secondary); }
  icon.edit { cursor: pointer; }

`],
    standalone: true,
    imports: [ActionButtonComponent, IconComponent, CommonModule, DeleteButtonComponent],
})
export class BrandingControlsWrapperComponent {
  @Input() selected: boolean
  @Input() isAccountDefault: boolean
  @Input() editing: boolean
  @Input() canRemove = false
  @Input() onAccount

  @Input() hideDelete: boolean
  @Input() showEdit: boolean = false

  @Input() deleteTitle: string
  @Input() deleteText: string

  @Output() select: EventEmitter<void> = new EventEmitter()
  @Output() unselect: EventEmitter<void> = new EventEmitter()
  @Output() delete: EventEmitter<void> = new EventEmitter()
  @Output() edit: EventEmitter<boolean> = new EventEmitter()

  @Output() setAsAccountDefault: EventEmitter<void> = new EventEmitter()

  

}
